import script from "./MaterialLotListView.vue?vue&type=script&setup=true&lang=js"
export * from "./MaterialLotListView.vue?vue&type=script&setup=true&lang=js"

import "./MaterialLotListView.vue?vue&type=style&index=0&id=23c0e19b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23c0e19b"]])

export default __exports__